// Event types that contribute to derating / unallocated calculation
export const DERATE_TYPES = new Set([
  'D1',
  'D2',
  'D3',
  'D4',
  'DE',
  'PD',
  'DM',
  'DP',
])

// Unplanned / forced outage types (full outage — availCap locked to 0)
export const OUTAGE_TYPES = new Set(['U1', 'U2', 'U3', 'SF', 'RS'])

// Event types that force availCap = 0 and disable the input field
export const ZERO_CAP_TYPES = new Set(['RS', 'U1', 'U2', 'U3', 'SF'])
